// Smooth-scrolls to the in-page section referenced by a link's hash, matching the
// anchor behaviour used on the other landing pages.
/** @param {MouseEvent} event */
export function handleAnchorClick(event) {
	event.preventDefault();
	const link = /** @type {HTMLAnchorElement} */ (event.currentTarget);
	const anchor = document.getElementById(new URL(link.href).hash.replace('#', ''));
	if (anchor) {
		window.scrollTo({ top: anchor.offsetTop, behavior: 'smooth' });
	}
}
